import { A } from '../actions/app';
import update from 'immutability-helper';

const initialState = {
  preloadingIsDone: false,
  appSavedState: localStorage.getItem('Kak2cSavedState')
    ? JSON.parse(localStorage.getItem('Kak2cSavedState'))
    : {
        paginations: {},
      },
};

const app = (state = initialState, action) => {
  switch (action.type) {
    case A.SET_PRELOADING_STATE:
      return update(state, {
        preloadingIsDone: { $set: action.status },
      });

    case A.SET_PAGINATION_PER_PAGE_VALUE:
      return update(state, {
        appSavedState: {
          paginations: { [action.data.key]: { $set: action.data.value } },
        },
      });

    default:
      return state;
  }
};

export default app;
